import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const Breadcrumbs = ({ trail }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex items-center gap-2 text-xs text-white/50 flex-wrap">
    <Link to="/" className="flex items-center gap-1 hover:text-cyan transition-colors">
      <Home size={12} />
    </Link>
    {trail.map((item, i) => (
      <span key={i} className="flex items-center gap-2">
        <ChevronRight size={12} className="text-white/20" />
        {item.href ? (
          <Link to={item.href} data-testid={`breadcrumb-${i}`} className="hover:text-cyan transition-colors">
            {item.label}
          </Link>
        ) : (
          <span data-testid={`breadcrumb-${i}`} className="text-white font-medium">{item.label}</span>
        )}
      </span>
    ))}
  </nav>
);
